import { useImmerAtom } from 'jotai-immer';
import { EditStateGroup, EditStateHook } from '../groups_create_types';
import { editStateGroupsCreateAtom } from '../groups_create_atoms';

export const useGroupsCreateState = (): EditStateHook => {
    const [state, _setState] = useImmerAtom(editStateGroupsCreateAtom);

    const setState = (draft: Partial<EditStateGroup>): void => {
        _setState(current => ({ ...current, ...draft }));
    };

    return {
        ...state,
        setState,
    };
};
